import {
    RSS_ARTICLES_REQUEST, RSS_ARTICLES_SUCCESS, RSS_ARTICLES_FAIL,
    RSS_FEEDS_LIST_REQUEST, RSS_FEEDS_LIST_SUCCESS, RSS_FEEDS_LIST_FAIL,
    RSS_FEED_CREATE_REQUEST, RSS_FEED_CREATE_SUCCESS, RSS_FEED_CREATE_FAIL,
    RSS_FEED_UPDATE_REQUEST, RSS_FEED_UPDATE_SUCCESS, RSS_FEED_UPDATE_FAIL,
    RSS_FEED_DELETE_REQUEST, RSS_FEED_DELETE_SUCCESS, RSS_FEED_DELETE_FAIL,
} from '../constants/rssConstants'

export const rssArticlesReducer = (state = { articles: [] }, action) => {
    switch (action.type) {
        case RSS_ARTICLES_REQUEST: return { loading: true,  articles: [] }
        case RSS_ARTICLES_SUCCESS: return { loading: false, articles: action.payload }
        case RSS_ARTICLES_FAIL:    return { loading: false, error: action.payload, articles: [] }
        default:                   return state
    }
}

// RSS Feed Management Reducers
export const rssFeedsListReducer = (state = { feeds: [] }, action) => {
    switch (action.type) {
        case RSS_FEEDS_LIST_REQUEST: return { loading: true, feeds: [] }
        case RSS_FEEDS_LIST_SUCCESS: return { loading: false, feeds: action.payload }
        case RSS_FEEDS_LIST_FAIL:    return { loading: false, error: action.payload, feeds: [] }
        default:                     return state
    }
}

export const rssFeedCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case RSS_FEED_CREATE_REQUEST: return { loading: true }
        case RSS_FEED_CREATE_SUCCESS: return { loading: false, success: true, feed: action.payload }
        case RSS_FEED_CREATE_FAIL:    return { loading: false, error: action.payload }
        default:                      return state
    }
}

export const rssFeedUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case RSS_FEED_UPDATE_REQUEST: return { loading: true }
        case RSS_FEED_UPDATE_SUCCESS: return { loading: false, success: true, feed: action.payload }
        case RSS_FEED_UPDATE_FAIL:    return { loading: false, error: action.payload }
        default:                      return state
    }
}

export const rssFeedDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case RSS_FEED_DELETE_REQUEST: return { loading: true }
        case RSS_FEED_DELETE_SUCCESS: return { loading: false, success: true }
        case RSS_FEED_DELETE_FAIL:    return { loading: false, error: action.payload }
        default:                      return state
    }
}
